import React from 'react';
import Modal from '../Modal';
import ScheduleTourFormContainer from '../../containers/ScheduleTourFormContainer';
import './styles.scss';

class ScheduleTourModal extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Modal id='tourModal' persistent={false} {...this.props}>
        <ScheduleTourFormContainer utmParams={this.props.utmParams} />
      </Modal>
    )
  }
}

export default ScheduleTourModal;


// WEBPACK FOOTER //
// ./client/components/ScheduleTourModal/index.js